// ⚠️ 重要：本利用規約は実際のサービス運用前に必ず弁護士のレビューを受けてください。
// 本ファイルはドラフトであり、現状のままでの法的有効性は保証されません。
//
// 改定時は LAST_UPDATED / EFFECTIVE_DATE を更新し、必要に応じて
// profiles.verified_consent_version との比較で再同意を促す仕組みを
// 別途実装してください（ステップ6.2のTODO参照）。

export const TERMS_LAST_UPDATED = "2026年5月1日";
export const TERMS_EFFECTIVE_DATE = "2026年5月1日";

export const TERMS_PREAMBLE =
  "この利用規約（以下「本規約」といいます）は、KAGEM（以下「本サービス」といいます）の利用条件を定めるものです。本サービスを利用することにより、本規約に同意したものとみなされます。";

export interface TermsArticle {
  id: string;
  number: number;
  title: string;
  /** 各段落（本文）。先頭の文字列が項番号付きリストの場合は items を使う。 */
  paragraphs?: string[];
  /** 番号付き列挙項目 */
  items?: string[];
  /** 末尾の補足段落 */
  trailing?: string[];
}

export const TERMS_ARTICLES: TermsArticle[] = [
  {
    id: "article-1",
    number: 1,
    title: "定義",
    paragraphs: ["本規約において使用する用語の定義は、以下のとおりとします。"],
    items: [
      "「本サービス」とは、当社が提供するAI動画生成サービス「KAGEM」を指します。",
      "「当社」とは、本サービスを運営する事業者を指します。",
      "「ユーザー」とは、本規約に同意のうえ本サービスを利用する個人または法人を指します。",
      "「コンテンツ」とは、ユーザーが本サービスにアップロードする画像・動画その他一切のデータを指します。",
      "「生成動画」とは、本サービスを通じて生成された動画を指します。",
      "「クレジット」とは、本サービス上で生成動画の作成に消費される利用権を指します。",
      "「サブスクリプション」とは、本サービスが提供する月額課金型の継続利用プランを指します。",
    ],
  },
  {
    id: "article-2",
    number: 2,
    title: "本サービスの内容",
    paragraphs: [
      "本サービスは、ユーザーがアップロードした画像または動画をもとに、AIを用いて新たな動画を生成するサービスです。",
      "本サービスは、生成品質に応じた複数のプランおよびクレジット制度を提供します。提供される機能の詳細は、本サービス上で別途案内するものとします。",
    ],
  },
  {
    id: "article-3",
    number: 3,
    title: "利用登録",
    paragraphs: [
      "本サービスの利用希望者は、当社所定の方法により利用登録を申請し、当社がこれを承認することによりユーザーとなります。",
      "ユーザーは、登録に際し、真実かつ正確な情報を提供しなければなりません。虚偽の情報を登録した場合、当社は当該ユーザーの登録を取り消すことができます。",
      "本サービスは18歳以上の方のみ利用できます。18歳未満の方による利用は禁止します。",
      "ユーザーは、自己の責任において登録情報を管理するものとし、第三者による不正利用について当社は責任を負いません。",
    ],
  },
  {
    id: "article-4",
    number: 4,
    title: "禁止事項",
    paragraphs: [
      "ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。",
    ],
    items: [
      "法令または公序良俗に違反する行為",
      "犯罪行為に関連する行為",
      "第三者の肖像権、著作権、プライバシー権、名誉権その他の権利または利益を侵害する行為",
      "本人の同意なく、有名人・公人・芸能人その他第三者の画像または映像を用いて生成動画を作成する行為",
      "未成年者を被写体とするコンテンツの生成、またはこれを示唆するコンテンツの生成",
      "性的、暴力的、残虐的、または違法なコンテンツの生成",
      "なりすまし、詐欺、誹謗中傷、嫌がらせ、ストーキングその他の有害な目的での利用",
      "本サービスのサーバーまたはネットワークに過度な負荷をかける行為、本サービスの運営を妨害する行為",
      "本サービスのリバースエンジニアリング、逆コンパイル、自動化された手段による大量利用",
      "当社の事前の承諾なく、本サービスを第三者に利用させ、または再販売する行為",
      "その他、当社が不適切と判断する行為",
    ],
  },
  {
    id: "article-5",
    number: 5,
    title: "本サービスの提供の停止等",
    paragraphs: [
      "当社は、以下のいずれかに該当する場合、ユーザーに事前通知することなく本サービスの全部または一部の提供を停止または中断することができます。",
    ],
    items: [
      "本サービスの保守点検または更新を行う場合",
      "地震、落雷、火災、停電、天災等の不可抗力により本サービスの提供が困難となった場合",
      "コンピュータまたは通信回線等が事故により停止した場合",
      "第三者AIサービスに障害が発生した場合",
      "その他、当社が本サービスの提供が困難と判断した場合",
    ],
    trailing: [
      "当社は、本条に基づく本サービスの提供の停止または中断によりユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。",
    ],
  },
  {
    id: "article-6",
    number: 6,
    title: "著作権・知的財産権",
    paragraphs: [
      "ユーザーは、本サービスにアップロードするコンテンツについて、自己が必要な権利を有していることまたは正当な権限に基づき利用していることを表明し、保証するものとします。",
      "生成動画に関する権利は、原則としてユーザーに帰属します。ただし、ユーザーは、当社に対し、本サービスの提供、改善、品質向上およびモデル評価の目的で生成動画およびコンテンツを利用することを、無償・非独占的に許諾するものとします。",
      "本サービスにおける商用利用の可否は、ユーザーが契約するプランごとに異なります。Proプラン以外のプランで生成された生成動画については、商用利用を禁止します。商用利用の範囲については、本サービス上で別途案内するものとします。",
      "本サービス自体に関する著作権、商標権その他の知的財産権は、当社または当社にライセンスを許諾している者に帰属します。",
    ],
  },
  {
    id: "article-7",
    number: 7,
    title: "利用料金および支払方法",
    paragraphs: [
      "本サービスの利用料金は、本サービス上で定めるとおりとします。現行のプランは以下のとおりです（金額はいずれも消費税込み・内税）。",
    ],
    items: [
      "Freeプラン：月額0円",
      "Lightプラン：月額980円",
      "Standardプラン：月額2,980円",
      "Proプラン：月額7,980円",
      "クレジット買い切り：10クレジットあたり100円から（プランにより単価が異なる場合があります）",
    ],
    trailing: [
      "支払方法は、クレジットカード（決済代行：Stripe）によるものとします。",
      "当社は適格請求書発行事業者として登録されており、ユーザーの求めに応じて適格請求書（インボイス）を発行します。",
      "ユーザーが利用料金の支払を遅滞した場合、当社は当該ユーザーの本サービスの利用を停止することができます。",
    ],
  },
  {
    id: "article-8",
    number: 8,
    title: "クレジット制度",
    paragraphs: [
      "クレジットは、本サービス上で生成動画の作成に消費される利用権です。クレジットの取扱いは以下のとおりとします。",
    ],
    items: [
      "買い切り型クレジットの有効期限は、購入日から6ヶ月とします。",
      "サブスクリプションプランで毎月付与されるクレジットは、当該月内のみ利用可能であり、翌月以降への繰越はできません。",
      "ユーザーの自己都合による解約・返金は、原則として行いません。ただし、消費者契約法その他関係法令により解除権が認められる場合はこの限りではありません。",
      "未使用のクレジット残高は、解約またはアカウント削除をもって失効するものとし、返金請求権は発生しません。",
    ],
  },
  {
    id: "article-9",
    number: 9,
    title: "第三者AIサービスの利用",
    paragraphs: [
      "本サービスは、動画生成のため、Kling、HeyGen、Akool、Replicateその他の第三者が提供するAIサービス（以下「第三者AIサービス」といいます）を利用しています。",
      "ユーザーは、本サービスにアップロードしたコンテンツが、生成処理のために第三者AIサービスに送信されることに同意するものとします。",
      "第三者AIサービスにおけるデータの取扱いについては、各第三者AIサービスのプライバシーポリシーおよび利用規約が適用されます。ユーザーは、必要に応じてこれらを確認するものとします。",
      "当社は、第三者AIサービスの障害、エラー、データの取扱いその他第三者AIサービスに起因する事項について、一切の責任を負いません。",
    ],
  },
  {
    id: "article-10",
    number: 10,
    title: "音声変換機能",
    paragraphs: [
      "当社は動画内の音声を別の声質へ変換する機能を提供します。ユーザーは、変換対象の音声が自己のもの、または権利者の許諾を得たものであることを保証し、実在の人物になりすます目的、詐欺・誹謗中傷その他違法な目的で本機能を利用しないものとします。",
      "本機能の利用時間はプランごとに日次・月次上限を設けます。上限は事前告知の上で変更する場合があります。",
      "入力動画および中間音声は原則24時間（最長72時間）で自動削除され、完成動画はプラン所定の保存期間経過後に削除されます。処理過程で音声データはElevenLabs（米国）へ送信されます。",
      "他人の声を無断で複製する行為、政治的・宗教的な偽情報の作成、音声認証の突破を目的とする利用を禁止します。違反が確認された場合、当社は当該コンテンツの削除、機能の停止、アカウントの停止その他必要な措置を講じることができ、これにより生じた損害について当社は責任を負いません。",
    ],
  },
  {
    id: "article-11",
    number: 11,
    title: "免責事項",
    paragraphs: [
      "当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティ等に関する欠陥、エラーやバグ、権利侵害等を含みます）がないことを明示的にも黙示的にも保証しません。",
      "当社は、本サービスの中断、停止、終了、利用不能または変更、ユーザーが本サービスに送信したメッセージまたは情報の削除または消失、ユーザー登録の抹消、本サービスの利用による生成動画またはデータの消失等、本サービスに関連してユーザーが被った損害について、一切の責任を負いません。",
      "ユーザーが生成したコンテンツに起因または関連して、当社が第三者からクレーム、請求、訴訟等を受けた場合、ユーザーは自己の責任と費用においてこれを解決するものとし、当社に損害が生じた場合は当該損害を賠償するものとします。",
      "当社は、第三者AIサービスの不具合、品質、結果の妥当性等について一切の責任を負いません。",
      "前各項の規定は、当社の故意または重過失による場合には適用されません（消費者契約法その他の強行法規に反する免責は無効とします）。",
      "当社が本サービスに関しユーザーに対して損害賠償責任を負う場合、その賠償額は、損害発生の直前12ヶ月間に当該ユーザーが本サービスに対して支払った利用料金の総額を上限とします。ただし、当社の故意または重過失による場合はこの限りではありません。",
    ],
  },
  {
    id: "article-12",
    number: 12,
    title: "本サービス内容の変更・終了",
    paragraphs: [
      "当社は、ユーザーに事前に通知することにより、本サービスの内容を変更し、または本サービスの提供を終了することができます。",
      "本サービスの提供を終了する場合、当社は、未使用のクレジット残高の取扱いについて、合理的な範囲で別途定めるものとします。",
    ],
  },
  {
    id: "article-13",
    number: 13,
    title: "利用規約の変更",
    paragraphs: [
      "当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。ただし、ユーザーに重要な影響を及ぼす変更については、相当な周知期間をもって、本サービス上での掲示またはメール送信その他適切な方法により告知するものとします。",
      "本規約の変更後、ユーザーが本サービスの利用を継続した場合、当該ユーザーは変更後の本規約に同意したものとみなします。",
    ],
  },
  {
    id: "article-14",
    number: 14,
    title: "個人情報の取扱い",
    paragraphs: [
      "当社は、本サービスの利用によって取得する個人情報については、別途定める「プライバシーポリシー」に従い適切に取り扱うものとします。",
    ],
  },
  {
    id: "article-15",
    number: 15,
    title: "通知または連絡",
    paragraphs: [
      "ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先に通知または連絡を行い、これらは発信時にユーザーへ到達したものとみなします。",
    ],
  },
  {
    id: "article-16",
    number: 16,
    title: "権利義務の譲渡の禁止",
    paragraphs: [
      "ユーザーは、当社の書面による事前の承諾なく、本規約に基づく権利または義務を第三者に譲渡し、または担保に供することはできません。",
    ],
  },
  {
    id: "article-17",
    number: 17,
    title: "準拠法・裁判管轄",
    paragraphs: [
      "本規約の解釈にあたっては、日本法を準拠法とします。",
      "本サービスに関して当社とユーザーとの間で紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。",
    ],
  },
];
